class ConfiguratorExtras extends HTMLElement {
  constructor() {
    super();

    this.drawer = document.querySelector("configurator-drawer");
    this.form = this.querySelector("form");
    this.submitButton = this.querySelector('button[type="submit"]');
    this.backButton = this.querySelector('button.drawer__back');
    this.previousSteps = {};
    this.footer = this.querySelector('.drawer__footer');
    this.framePrice = this.querySelector('.drawer__footer #FramePrice .price_container').dataset.amount / 100

    this.renderFooter();
    this.getPreviousSteps();
    this.setListeners();
    this.disableUnavailableOptionsInitially();

    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    this.form.addEventListener('change', () => {
      this.disableUnavailableOptionsOnChange();
      this.updateTotalPriceOnChange();
    });

    this.submitButton.removeAttribute('disabled');
  }

  setListeners() {
    const options = this.querySelectorAll('.drawer__form_option');

    options.forEach((option) => {
      const checkbox = option.querySelector('input[type=checkbox]');
      const radios = option.querySelectorAll('input[type=radio]');

      checkbox.addEventListener('change', (event) => {
        if (!radios.length || event.target.checked) return

        radios.forEach((radio) => radio.checked = false);
      });
    })
  }

  disableUnavailableOptionsInitially() {
    const optionElements = this.querySelectorAll('.drawer__form_option');
    const currentConfig = this.drawer.bundle;
    
    // define options
    const blueLightOption = [...optionElements].find((optionElement) => optionElement.querySelector('#blue-light-filter') != null);
    const lotusEffectOption = [...optionElements].find((optionElement) => optionElement.querySelector('#lotuseffect') != null);
    const tintOption = [...optionElements].find((optionElement) => optionElement.querySelector('#tint') != null);
    const gradientOption = [...optionElements].find((optionElement) => optionElement.querySelector('#gradient') != null);
    const polarisedOption = [...optionElements].find((optionElement) => optionElement.querySelector('#polarised') != null);
    const sightfieldOption = [...optionElements].find((optionElement) => optionElement.querySelector('#sightfield') != null);

    // disable unavailable options

    if (currentConfig.focus != 'double') this.disableOptionCompletely(sightfieldOption, 'Nur mit Gleitsichtbrille kompatibel');

    if (currentConfig.focus == 'work') {
      this.disableOptionCompletely(polarisedOption, 'Nicht kompatibel mit Arbeitsplatzbrille');
      this.disableOptionCompletely(gradientOption, 'Nicht kompatibel mit Arbeitsplatzbrille');
      this.disableOptionCompletely(tintOption, 'Nicht kompatibel mit Arbeitsplatzbrille');
    }

    if (currentConfig.focus == 'single' && currentConfig.thickness == 'extra-thin') {
      this.disableOptionCompletely(polarisedOption, 'Nicht kompatibel mit extradünnen Einstärkenbrille');
      this.disableOptionCompletely(gradientOption, 'Nicht kompatibel mit extradünnen Einstärkenbrille');
      this.disableOptionCompletely(tintOption, 'Nicht kompatibel mit extradünnen Einstärkenbrille');
    }

    if (currentConfig.focus == 'double') {
      const sightfieldVariants = sightfieldOption.querySelectorAll('.option_variant');
      const quality = currentConfig.quality;

      if (quality == 'myglasses-comfort') {
        [...sightfieldVariants].filter((variant) => variant.getAttribute('for').includes('Pro')).forEach((variant) => variant.remove());
      } else if (quality == 'myglasses-pro') {
        [...sightfieldVariants].filter((variant) => variant.getAttribute('for').includes('Comfort')).forEach((variant) => variant.remove());
      }
    }
  }

  disableUnavailableOptionsOnChange() {
    const optionElements = this.querySelectorAll('.drawer__form_option');
    const currentConfig = this.drawer.bundle;
    const formData = new FormData(this.form);
    const formValues = Object.fromEntries([...formData]);
    
    // define options
    const blueLightOption = [...optionElements].find((optionElement) => optionElement.querySelector('#blue-light-filter') != null);
    const lotusEffectOption = [...optionElements].find((optionElement) => optionElement.querySelector('#lotuseffect') != null);
    const tintOption = [...optionElements].find((optionElement) => optionElement.querySelector('#tint') != null);
    const gradientOption = [...optionElements].find((optionElement) => optionElement.querySelector('#gradient') != null);
    const polarisedOption = [...optionElements].find((optionElement) => optionElement.querySelector('#polarised') != null);
    const sightfieldOption = [...optionElements].find((optionElement) => optionElement.querySelector('#sightfield') != null);

    // re-enable available options

    for (const option of [blueLightOption, tintOption, gradientOption, polarisedOption]) {
      // if extra is not available for the configuration - skip, since html is not rendering in this case
      if (!option) continue;

      option.removeAttribute('disabled');
      if (option.querySelector('.disabled_notice')) option.querySelector('.disabled_notice').remove();
    }

    // disable unavailable options

    if ('polarisedId' in formValues) {
      this.disableOptionTemporarely(blueLightOption, 'Nicht kombinierbar mit Polarisierung');
      this.disableOptionTemporarely(gradientOption, 'Nicht kombinierbar mit Polarisierung');
      this.disableOptionTemporarely(tintOption, 'Nicht kombinierbar mit Polarisierung');
    }

    if ('gradientId' in formValues) {
      this.disableOptionTemporarely(blueLightOption, 'Nicht kombinierbar mit Verlauf');
      this.disableOptionTemporarely(polarisedOption, 'Nicht kombinierbar mit Verlauf');
      this.disableOptionTemporarely(tintOption, 'Nicht kombinierbar mit Verlauf');
    }

    if ('tintId' in formValues) {
      this.disableOptionTemporarely(blueLightOption, 'Nicht kombinierbar mit Tönung');
      this.disableOptionTemporarely(gradientOption, 'Nicht kombinierbar mit Tönung');
      this.disableOptionTemporarely(polarisedOption, 'Nicht kombinierbar mit Tönung');
    }

    if ('blue-light-filter' in formValues) {
      this.disableOptionTemporarely(tintOption, 'Nicht kombinierbar mit Blaulichtfilter');
      this.disableOptionTemporarely(gradientOption, 'Nicht kombinierbar mit Blaulichtfilter');
      this.disableOptionTemporarely(polarisedOption, 'Nicht kombinierbar mit Blaulichtfilter');
    }

    // re-enable available options
    
    // if (!('polarisedId' in formValues || 'gradientId' in formValues || 'tintId' in formValues)) {
    //   blueLightOption.removeAttribute('disabled');

    //   if (blueLightOption.querySelector('.disabled_notice')) blueLightOption.querySelector('.disabled_notice').remove();
    // }

    // if (!('blue-light-filter' in formValues)) {
    //   tintOption.removeAttribute('disabled');
    //   gradientOption.removeAttribute('disabled');
    //   polarisedOption.removeAttribute('disabled');

    //   if (tintOption.querySelector('.disabled_notice')) tintOption.querySelector('.disabled_notice').remove();
    //   if (gradientOption.querySelector('.disabled_notice')) gradientOption.querySelector('.disabled_notice').remove();
    //   if (polarisedOption.querySelector('.disabled_notice')) polarisedOption.querySelector('.disabled_notice').remove();
    // }
  }

  disableOptionTemporarely(optionElement, message = 'Nicht kompatibel mit ausgewählten Extras') {
    if (!optionElement) return;
    if (optionElement.hasAttribute('disabled')) return;

    const noticeElement = document.createElement('span');
    noticeElement.classList.add('notice');
    noticeElement.classList.add('caption_text__thin');
    noticeElement.classList.add('disabled_notice');
    noticeElement.style = 'white-space: unset; color: initial;';
    noticeElement.innerText = message;

    optionElement.appendChild(noticeElement);
    optionElement.setAttribute('disabled', '');
  }

  disableOptionCompletely(optionElement, message = 'Nicht kompatibel mit vorheriger Auswahl') {
    const noticeElement = document.createElement('span');
    noticeElement.classList.add('notice');
    noticeElement.classList.add('caption_text__thin');
    noticeElement.classList.add('disabled_notice');
    noticeElement.style = 'white-space: unset; color: initial;';
    noticeElement.innerText = message;

    optionElement.appendChild(noticeElement);
    optionElement.querySelectorAll('input').forEach((input) => input.remove());
    optionElement.setAttribute('disabled', '');
  }

  updateTotalPriceOnChange() {
    const totalPriceContainer = this.footer.querySelector('#configurator_subtotal .price_container');
    const priceWithoutExtras = parseInt(totalPriceContainer.dataset.amount);

    const formData = new FormData(this.form);
    const formValues = Object.fromEntries([...formData]);

    let chosenOptionLabelsHtml = '';
    let chosenExtrasSubtotalPrice = 0;

    for (const [extraOptionIdentifier, extraOptionVariantId] of Object.entries(formValues)) {
      const formValuePrice = this.drawer.extrasPrices.find(({variantId}) => String(variantId) == extraOptionVariantId)
      chosenExtrasSubtotalPrice += parseInt(formValuePrice.variantPrice);

      const extraPriceHtml = `
      <div class="configured-option-label">
        +<b>
          <span class="price_container">${(formValuePrice.variantPrice / 100).toFixed(2).replace('.', ',')}</span> €
        </b>
        ${this.drawer.optionConfig.extras.find(({identifier}) => identifier == extraOptionIdentifier.replace('Id', '')).title}
      </div>`

      chosenOptionLabelsHtml += extraPriceHtml;
    }

    this.footer.querySelector('#chosenExtras').innerHTML = chosenOptionLabelsHtml;
    totalPriceContainer.innerText = ((priceWithoutExtras + chosenExtrasSubtotalPrice) / 100).toFixed(2).replace('.', ',');
  }

  onSubmitHandler(evt) {
    evt.preventDefault();
    if (this.submitButton.getAttribute("aria-disabled") === "true") return;

    this.submitButton.setAttribute("aria-disabled", true);
    this.submitButton.classList.add("loading");

    const formData = new FormData(this.form);

    if ([...formData.keys()].length) {
      const extras = [];
      formData.keys().forEach((key) => extras.push(key));
      this.drawer.updateBundle("extras", extras);
    }

    this.addToCart();

    this.submitButton.setAttribute("aria-disabled", false);
    this.submitButton.classList.remove("loading");
  }

  generateItemsFromConfiguration() {
    const config = this.drawer.bundle;

    const frameId = config.frameId;
    const glassVariant = config.glassVariant;
    const extras = config.extras;
    const acuity = config.acuity;
    const appointment = config.appointment;

    const items = [];

    if (frameId) {
      items.push({
        id: frameId,
        quantity: 1,
        properties: {
          "_bundleParent": true
        }
      });
    }

    if (glassVariant) {
      const glassItem = {
        id: glassVariant.id,
        quantity: 1,
      };

      glassItem.properties = {
        "_acuity": JSON.stringify(acuity),
      };

      if (acuity == "appointment" && appointment) {
        glassItem.properties["_appointment"] = appointment;
      }

      items.push(glassItem);
    }

    if (extras) {
      extras.forEach((extra) => {
        const formData = new FormData(this.form);
        const extraId = formData.get(extra);

        if (!extraId) return;

        items.push({
          id: extraId,
          quantity: 1,
        });
      });
    }

    return items.reverse();
  }

  addToCart() {
    const items = this.generateItemsFromConfiguration();
    const bundleIdProperty = {
      "_bundleId": new Date().getTime()
    };

    // reference bundleId in each item
    items.forEach((item) => item.properties = {...item.properties, ...bundleIdProperty});

    const config = {
      headers: {
        "Content-Type": "application/json",
      },
      method: "POST",
      body: JSON.stringify({
        items: items,
      }),
    };

    fetch("/cart/add.js", config)
      .then((response) => response.json())
      .then(() => (window.location = window.routes.cart_url))
      .catch((e) => {
        console.error(e);
      });
  }

  getPreviousSteps() {
    fetch("?sections=configurator-acuity")
      .then((response) => response.json())
      .then((response) => {
        this.previousSteps["acuity"] = response["configurator-acuity"];
        this.backButton.removeAttribute('disabled');
      })
      .catch((e) => {
        console.error(e);
      });
  }

  renderPreviousStep() {
    this.drawer.renderContents(this.previousSteps["acuity"]);
  }

  renderFooter() {
    const chosenGlassTitle = this.drawer.bundle.glassVariant.title;
    const chosenGlassPrice = this.drawer.bundle.glassVariant.price / 100;

    const span = document.createElement('span');
    span.innerText = chosenGlassTitle;
    this.footer.querySelector('#chosenGlass').appendChild(span);
    this.footer.querySelector('#chosenGlass .price_container').innerText = chosenGlassPrice;
    this.footer.querySelector('#chosenGlass').removeAttribute('style');

    const totalPriceContainer = this.footer.querySelector('#configurator_subtotal .price_container');
    const framePrice = totalPriceContainer.dataset.amount / 100;
    const totalPrice = framePrice + chosenGlassPrice;

    totalPriceContainer.innerText = String(totalPrice.toFixed(2)).replace('.', ',');
    totalPriceContainer.dataset.amount = parseInt(totalPrice * 100);
  }
}

customElements.define("configurator-extras", ConfiguratorExtras);
